export const redirectUSLink = 'https://app.esgisoftware.com';
export const redirectCanadaLink = 'https://app.ca.esgisoftware.com';